import React from 'react';
import { connect } from 'react-redux';
import { numberWithDollarSign, getOrdinal, numberWithCommas, decimalNumberWithDollarSign } from './Helpers';

const MapTooltip = (props) => {
    const spendingType = props.tablename.charAt(0).toUpperCase() + props.tablename.slice(1);
    console.log(props.hoverFeature.properties);
    const congressDistrictId = props.hoverFeature.properties.CD119FP;
    let statefips = props.hoverFeature.properties.STATEFP;
    
    const stateNameWithApostrophy = ((props.usStateList.filter(state => state.statecode == statefips)[0].statename).slice(-1) == 's')
        ? `${props.usStateList.filter(state => state.statecode == statefips)[0].statename}'`
        : `${props.usStateList.filter(state => state.statecode == statefips)[0].statename}'s`

    const exceptionForBaltimore = (props.hoverFeature.properties.GEOID == "24510" || props.hoverFeature.properties.GEOID == "29510") ? " City" : " County";

    const location = !props.isCongress
        ? props.isEmployee
            ? props.hoverFeature.properties.NAME
            : `${props.hoverFeature.properties.NAME + exceptionForBaltimore}, ${props.USState.filter(state => state.statecode == statefips)[0].statename}`
        : `${stateNameWithApostrophy} ${getOrdinal(+congressDistrictId)} Congressional District`;

    const content = !props.data[0]
        ? <p>{props.isEmployee ? "No employees found" : "No spending identified"}</p>
        : <div>
            <p>
                {(!props.isEmployee)
                    ? `${spendingType === "All" ? "" : spendingType} Expenditures: ${
                    (props.data[0][!props.isCongress ? 'total' : 'payment_amt'] !== 0)
                        ? decimalNumberWithDollarSign(props.data[0][!props.isCongress ? 'total' : 'payment_amt'])
                        : 0}`   
                    :
                    (props.data[0]['count'] <= 4)
                        ? '<5 (masked for privacy)'
                        : `Employee Count: ${numberWithCommas(props.data[0]['count'])}`
                }
            </p>
            {
                (!props.isCongress && !props.isEmployee && !props.agg)&&
				<div>
                        <p>{props.tablename === "all" ? `Top vendors & subawards:` : props.tablename === "vendor" ? `Top vendors:` : `Top subawards:`}</p>
                    <ul>
					    {
						    props.data.map((d, i) => <li key={`${i}`}>
							    {`${d.org_name}: ${numberWithDollarSign(d.payment)}`}
						    </li>)
                        }
                    </ul>
                </div>
            }

           </div>

    return <div className="charttooltip" style={props.position || undefined}>       
        <strong>{location}</strong>
        <br />
        {content}
    </div>

}

const mapStateToProps = state => ({
    usStateList: state.allReportsSharedProperties.USStateList
});

export default connect(mapStateToProps)(MapTooltip);